/* eslint-disable @typescript-eslint/ban-ts-comment */

/**
 * Recursively removes `__typename` fields from an object.
 * This is required to use objects as variables in GraphQL queries.
 */
export function removeTypenameFields<T extends Record<string, unknown>>(obj: T): T {
	if (obj === null || typeof obj !== 'object') {
		return obj; // If the object is not an object, return it as is
	}

	if (Array.isArray(obj)) {
		// @ts-ignore-error
		return obj.map((item) => removeTypenameFields(item));
	}

	// If the object is an object, process its properties
	const newObj = {};
	for (const key in obj) {
		if (key !== '__typename') {
			// @ts-ignore-error
			newObj[key] = removeTypenameFields(obj[key]);
		}
	}

	// @ts-ignore-error
	return newObj;
}
